export const DeviceQueries = {
  mobile: 'max-width: 767px',
  laptop: 'max-width: 1020px'
};
